import { IGif } from '@giphy/js-types'

const isAdInResult = (results: IGif[]) => {
    let adsFound = false
    for (let i = 0; i < 5; i++) {
        if (results[i] && results[i].bottle_data && Object.keys(results[i].bottle_data).length > 0) {
            adsFound = true
            break
        }
    }
    return adsFound
}

export default isAdInResult

export const getBouncerAdIndex = (results: IGif[]) => {
    for (let i = 0; i < 5; i++) {
        if (results[i] && results[i].bottle_data && Object.keys(results[i].bottle_data).length > 0) {
            return i
        }
    }
    return -1
}
